<template>
   <div>
     <v-collapse-wrapper :active="true">
       <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
            v-collapse-toggle>
         <h3>{{$t('form.lot.received-requests')}}</h3>
       </div>

       <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
         <template v-if="lot.state.RETEND || lot.state.WAITING_FOR_RETEND">
           <div class="a-tab__title-block admin__a-tab u-border-0">
             <div class="a-container-form " v-if="nextRetendRequestTimeLeft && retendTimeLeft">
               <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.due-date-for-next-bid')}}:</div>
               <div class="a-col-block-content ">
                 <timer :value="nextRetendRequestTimeLeft"></timer>
               </div>
             </div>
             <div class="a-container-form u-indent-m-b-45px" v-if="retendTimeLeft && nextRetendRequestTimeLeft">
               <div class="a-label a-col-label a-label--w-280">{{$t('form.lot.time-left-to-retend-finish')}}:</div>
               <div class="a-col-block-content ">
                 <timer :value="retendTimeLeft"></timer>
               </div>
             </div>
           </div>
         </template>

         <div class="a-ui-tab u-margin-b-24">
           <div class="a-ui-tab__block">
             <div class="a-ui-tab__content-block">
               <section v-maximizable>
                <div class="table-tab">
                 <div class="table-tab__container" style="overflow-x: auto">
                   <table class="table-tab__block table " style="width: 100%">
                     <thead class="table-tab__thead table-tab__border-bottom">
                       <tr class="">
                         <th>{{$t('form.lot.requests-table.bid-number')}}</th>
                         <th>{{$t('form.lot.requests-table.participant')}}</th>
                         <th>{{$t('form.lot.requests-table.request-status')}}</th>
                         <th>{{$t('form.lot.requests-table.bid-status')}}</th>
                         <template v-for="criterion in criteria">
                           <th>{{$t('form.lot.requests-table.criterion-estimation')}}: {{criterion.criterionName}}</th>
                         </template>
                         <th v-if="hasPrice">{{$t('form.lot.requests-table.price')}}</th>
                         <th v-if="hasCurrency">{{$t('form.lot.requests-table.bid-currency')}}</th>
                         <th v-if="hasCurrencyContract">{{$t('form.lot.requests-table.contract-currency')}}</th>
                         <th v-if="hasPresentPrice">{{$t('form.lot.requests-table.present-price')}}</th>
                         <th v-if="hasFinalEstimate">{{$t('form.lot.requests-table.final-estimation')}}</th>
                         <th v-if="hasFinalEstimate">{{$t('form.lot.requests-table.rating')}}</th>
                         <th></th>
                         <th class="table-tab__width-90"></th>
                       </tr>
                     </thead>

                     <request-overview :lot="lot"
                                       :request="request"
                                       :serial="idx + 1"
                                       :key="request.id"
                                       v-for="(request, idx) in lot.requests"></request-overview>
                   </table>
                 </div>
               </div>
               </section>
             </div>
           </div>
         </div>
       </div>
     </v-collapse-wrapper>
   </div>
</template>

<script>
  import _ from 'lodash'
  import RequestOverview from './requests/RequestOverview'
  import TimersMixins from './mixins/timers'
  import CommonMixins from './mixins/common'

  export default {
    props: {
      lot: Object
    },

    mixins: [
      CommonMixins,
      TimersMixins
    ],

    computed: {
      criteria() {
        return this.lot.criteria.expert.filter(c => !c.unit || !c.unit.CATALOG);
        // return [].concat(this.lot.criteria.expert, this.lot.criteria.reducedPrice);
      },

      hasPrice() {
        return _.some(this.lot.requests, r => _.some(r.bids, b => b.price !== undefined));
      },

      hasCurrency() {
        return _.some(this.lot.requests, r => _.some(r.bids, b => b.currencyBid !== undefined));
      },

      hasCurrencyContract() {
        return !this.lot.method.REDUCTION && _.some(this.lot.requests, r => _.some(r.bids, b => b.currencyPay !== undefined));
      },

      hasPresentPrice() {
        return !this.lot.method.REDUCTION && _.some(this.lot.requests, r => _.some(r.bids, b => b.presentPrice !== undefined));
      },

      hasFinalEstimate() {
        return !this.lot.method.REDUCTION && _.some(this.lot.requests, r => _.some(r.bids, b => b.estimate !== undefined));
      }
    },

    watch: {
      nextRetendRequestTimeLeft(value) {
        if (!value) {
          this.checkPublicLot();
        }
      },

      retendTimeLeft(value) {
        if (!value) {
          this.checkPublicLot();
        }
      }
    },

    components: {
      RequestOverview
    }
  }
</script>

<style scoped>

</style>
